module.exports = __webpack_public_path__ + "static/media/6.01a2023f.png";